module.exports = __webpack_public_path__ + "img/logo-premium-member.2f66e242.svg";